import api from "./api";

// Announcements — the compact text cards in a "What's New" rail. A title and a
// second line, no artwork: see m_announcement on the API side.
const announcementService = {
  // Paginated list. searchText matches the name, title and subtitle; status is
  // 'Y' or 'N' and is omitted to get both.
  getAnnouncements: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.perPage) qs.append("perPage", params.perPage);
    if (params.currentPage) qs.append("currentPage", params.currentPage);
    if (params.searchText) qs.append("searchText", params.searchText);
    if (params.status) qs.append("status", params.status);
    const query = qs.toString();
    return api.get(`/admin/announcement${query ? `?${query}` : ""}`);
  },

  getAnnouncementById: (id) => api.get(`/admin/announcement/${id}`),

  createAnnouncement: (payload) => api.post(`/admin/announcement`, payload),

  updateAnnouncement: (id, payload) => api.put(`/admin/announcement/${id}`, payload),

  deleteAnnouncement: (id) => api.delete(`/admin/announcement/${id}`),
};

export default announcementService;
